import VuexPersistence from 'vuex-persist';
import { createStore } from 'vuex';

import users from './modules/users';
import meta from './modules/meta';
import admin from './modules/admin';

const vuexLocal = new VuexPersistence({
  key: 'planeta_vivo',
  modules: ['users', 'admin'],
  storage: window.localStorage,
});

export default createStore({
  modules: {
    users,
    meta,
    admin
  },
  plugins: [vuexLocal.plugin]
});
